import type { PlumSupportedBrand } from '@newday/plum-types';

export const getUpdateUserDetailsLink = (brand: PlumSupportedBrand) =>
  `${process.env.PLUM_BASE_EXTERNAL_UPDATE_USERS}/${brand}/messages-and-settings/account-settings#personal-details`;
